import { BrowserRouter, Route, Routes } from "react-router-dom";
import Profile from "./components/Profile";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import CRM from "./pages/CRM";
import DashboardWow from "./pages/DashboardWow";
import Reviews from "./pages/Reviews";
import ManageSubscription from "./pages/ManageSubscription";
import Subscription from "./pages/Subscription";
import TicketPage from "./pages/TicketPage";
import SetupChannels from "./pages/SetupChannels";
import Pricing from "./components/Pricing";
import Reports from "./pages/Reports";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlatformScreen from "./components/Scan Screens/PlatformScreen";
import OnboadingContainer from "./components/NewOnboading/Pages/OnboadingContainer";
import ThankYouPage from "./components/NewOnboading/Pages/ThankYouPage";
import NewLoginPage from "./components/NewLoginPage";
import QrReadySucces from "./components/NewOnboading/Pages/QrReadySucces";
import CallbackApple from "./components/NewOnboading/Pages/CallbackApple";
import SummaryReport from "./pages/SummaryReport";
import ManageNewQR from "./pages/ManageNewQR";
import ClaritySetup from "./ClaritySetup";
import GmbDashboard from "./pages/GmbDashboard";
import FacebookDashboard from "./pages/FacebookDashboard";
import InstagramPanel from "./pages/InstagramPanel";
import TwitterPanel from "./pages/TwitterPanel";
import MenuManager from "./pages/MenuManager";
import TikTokPanel from "./pages/TikTokPanel";
import LinkedInPanel from "./pages/LinkedInPanel";
import SocialDashboard from "./pages/SocialDashboard";
import ThreadsPanel from "./pages/ThreadsPanel";
import IntelligenceDashboard from "./pages/IntelligenceDashboard";
import PinterestPanel from "./pages/PinterestPanel";
import KeywordPositions from "./pages/KeywordPositions";
import AnnualReport from "./pages/AnnualReport";
function App() {
  return (
    <>
      <BrowserRouter>
        <ClaritySetup />
        <RouteScrollToTop />
        <Routes>
          {/* NewPages Dashboard */}
          <Route exact path="/" element={<DashboardWow />} />
          <Route exact path="/Platform_screen" element={<PlatformScreen />} />
          <Route exact path="/profile" element={<Profile />} />
          <Route exact path="/crm" element={<CRM />} />
          <Route exact path="/Reviews" element={<Reviews />} />
          {/* <Route exact path="/sign-in" element={<NewLoginPage />} /> */}
          <Route
            exact
            path="/sign-in"
            element={
              <GoogleOAuthProvider clientId="1025063694947-vig9gf2j8f95srb0o6neicce6gibh9mv.apps.googleusercontent.com">
                <NewLoginPage />
              </GoogleOAuthProvider>
            }
          />
          {/* <Route exact path="/ManageQRcode" element={<ManageQR />} /> */}
          <Route exact path="/ManageQRcode" element={<ManageNewQR />} />
          <Route exact path="/ManageNewQRcode" element={<ManageNewQR />} />
          <Route exact path="/subscription" element={<ManageSubscription />} />
          <Route
            exact
            path="/subscription-expired"
            element={<Subscription />}
          />
          <Route exact path="/Support" element={<TicketPage />} />
          <Route exact path="/Menu-management" element={<MenuManager />} />
          {/* <Route exact path="/Onboard" element={<Onboading />} /> */}
          <Route exact path="/Pricing" element={<Pricing />} />
          <Route exact path="/reports" element={<Reports />} />
          <Route exact path="/thank_you" element={<ThankYouPage />} />
          <Route exact path="/sucees_page" element={<QrReadySucces />} />
          <Route exact path="/callbackapple" element={<CallbackApple />} />
          <Route exact path="/summaryreport" element={<SummaryReport />} />
          <Route
            exact
            path="/onboarding"
            element={
              <GoogleOAuthProvider clientId="1025063694947-vig9gf2j8f95srb0o6neicce6gibh9mv.apps.googleusercontent.com">
                <OnboadingContainer />
              </GoogleOAuthProvider>
            }
          />
          {/* <Route exact path="/sucees_page" element={<SuccessPage />} /> */}
          <Route
            exact
            path="/Setup-Review-Channels"
            element={
              <GoogleOAuthProvider clientId="1025063694947-vig9gf2j8f95srb0o6neicce6gibh9mv.apps.googleusercontent.com">
                <SetupChannels />
              </GoogleOAuthProvider>
            }
          />
          <Route exact path="/gmb_overview" element={<GmbDashboard />} />
          <Route exact path="/fb_overview" element={<FacebookDashboard />} />
          <Route path="/instagram_overview" element={<InstagramPanel />} />
          <Route path="/linkedin_overview" element={<LinkedInPanel />} />
          <Route path="/twitter_overview" element={<TwitterPanel />} />
          <Route path="/tiktok_overview" element={<TikTokPanel />} />
          <Route path="/threads_overview" element={<ThreadsPanel />} />
          <Route path="/pinterest_overview" element={<PinterestPanel />} />
          <Route path="/social-dashboard" element={<SocialDashboard />} />
          <Route path="/intelligence" element={<IntelligenceDashboard />} />
          <Route exact path="/annual_report" element={<AnnualReport />} />
        
          <Route
            exact
            path="/keyword_positions"
            element={<KeywordPositions />}
          />
          
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
